var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile-sub-title',{staticClass:"text-capitalize caption d-flex justify-end red--text",staticStyle:{"padding":".25em"}},[_c('v-layout',{class:{
    'justify-start': !_vm.center,
    'justify-center': _vm.center,
  },attrs:{"row":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"error"}},on),[_vm._v("timer")]),_c('span',_vm._g({staticClass:"pt-1 px-1"},on),[_vm._v(_vm._s(_vm.formatTimeRemaining(_vm.timeout)))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('time_remaining_before_cancelling_reservation')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }